import React from 'react';

const IconFacebook = ({ onClick }) => {
	return (
		<div className='IconFacebook' onClick={onClick}>
			<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path fillRule="evenodd" clipRule="evenodd" d="M15.4131 1.5V6.10114H12.3134V6.53704H15.4131V11.1382H12.3134V18.5H7.32479V11.1382H5V6.53704H7.32129C7.3443 5.92585 7.43369 5.11477 7.72395 4.34075C7.98909 3.6337 8.4357 2.90649 9.18294 2.36012C9.93528 1.81002 10.9149 1.5 12.1439 1.5H15.4131ZM8.26696 6.53704C8.25492 6.84582 8.26135 7.10975 8.26593 7.29757C8.26772 7.3712 8.26923 7.43313 8.26923 7.48148H5.94444V10.1937H8.26923V17.5556H11.3689V10.1937H14.4687V7.48148H11.3689V5.93162C11.3689 5.31168 11.8856 5.1567 12.1439 5.1567H14.4687V2.44444H12.1439C8.82615 2.44444 8.3258 5.02703 8.26696 6.53704Z" fill="#333333" />
			</svg>
		</div>
	)
}

export default IconFacebook;